import { useEffect, useState } from "react";

async function api(path, options) {
  return fetch(path, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
}

export function GroupRoster({ item, chapterId, canManage }) {
  const [roster, setRoster] = useState(null);
  const [members, setMembers] = useState([]);
  const [pick, setPick] = useState("");
  const [role, setRole] = useState("member");
  const [err, setErr] = useState("");

  function load() {
    api(`/api/groups/${item.id}/members`)
      .then((res) => (res.ok ? res.json() : { members: [] }))
      .then((d) => setRoster(d.members));
  }
  useEffect(load, [item.id]);
  useEffect(() => {
    api(`/api/chapters/${chapterId}/members`)
      .then((res) => (res.ok ? res.json() : { members: [] }))
      .then((d) => setMembers(d.members));
  }, [chapterId]);

  async function add(e) {
    e.preventDefault();
    setErr("");
    if (!pick) return;
    const res = await api(`/api/groups/${item.id}/members`, {
      method: "POST",
      body: JSON.stringify({ member_id: Number(pick), role }),
    });
    if (res.ok) {
      setPick("");
      setRole("member");
      const d = await res.json();
      setRoster(d.members);
    } else {
      setErr((await res.json().catch(() => ({}))).error || "Could not add.");
    }
  }
  async function remove(r) {
    await api(`/api/group-members/${r.id}`, { method: "DELETE" });
    load();
  }

  if (roster === null) return <p className="muted">Loading members…</p>;
  const inGroup = new Set(roster.map((r) => r.member_id));
  const available = members.filter((m) => !inGroup.has(m.id));

  return (
    <div style={{ padding: "4px 2px" }}>
      {canManage && (
        <form onSubmit={add} style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          <select value={pick} onChange={(e) => setPick(e.target.value)} style={{ width: "auto", minWidth: 200 }}>
            <option value="">Add a member…</option>
            {available.map((m) => (
              <option key={m.id} value={m.id}>{m.name}{m.email ? ` (${m.email})` : ""}</option>
            ))}
          </select>
          <select value={role} onChange={(e) => setRole(e.target.value)} style={{ width: "auto" }}>
            <option value="member">Member</option>
            <option value="lead">Lead</option>
          </select>
          <button className="btn-primary" style={{ width: "auto" }} type="submit" disabled={!pick}>Add</button>
          {err && <span className="err">{err}</span>}
        </form>
      )}

      {roster.length ? (
        <table className="tbl">
          <thead><tr><th>Name</th><th>Role</th><th>Joined</th>{canManage && <th />}</tr></thead>
          <tbody>
            {roster.map((r) => (
              <tr key={r.id}>
                <td>{r.name}{r.email && <><br /><span className="muted" style={{ fontSize: 12 }}>{r.email}</span></>}</td>
                <td>{r.role === "lead" ? "Lead" : "Member"}</td>
                <td>{r.joined_on || "—"}</td>
                {canManage && (
                  <td className="row-actions">
                    <button className="btn-danger" type="button" onClick={() => remove(r)}>Remove</button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="empty">No members in this group yet.</p>
      )}
    </div>
  );
}
